import React, {useState, useEffect} from 'react';
import {View} from 'react-native';
import isFinite from 'lodash/isFinite';
import {Divider} from 'react-native-paper';

import sy from '~/styles';
import {
  Dialog,
  FormNumberInput,
  Text,
  RadioButton,
} from '~/components/controls';
import Format from '~/lib/format';
import PropTypes from 'prop-types';

export const HOUR_TYPES = {
  work: 'work',
  suggested: 'suggested',
  custom: 'custom',
};

const DurationDialog = ({
  priceCheck,
  original_duration,
  duration: initial_value,
  work_source,
  work_time,
  calculated_work_time,
  sla,
  onChange,
  onDismiss,
}) => {
  const [duration, setDuration] = useState(initial_value);
  const [type, setType] = useState(HOUR_TYPES.custom);

  useEffect(() => {
    if (isFinite(work_time) && original_duration === null) {
      setType(HOUR_TYPES.work);
    } else if (
      (isFinite(priceCheck?.suggested_duration) &&
        initial_value === priceCheck?.suggested_duration) ||
      (isFinite(sla?.duration) && initial_value === sla?.duration)
    ) {
      setType(HOUR_TYPES.suggested);
    }
  }, [priceCheck, initial_value, work_time, sla]);

  return (
    <Dialog
      visible={true}
      title="Arbeidstijd"
      onDismiss={onDismiss}
      buttons={[
        {
          text: 'Annuleren',
          onPress: onDismiss,
        },
        {
          text: 'OK',
          onPress: () => {
            onChange(duration, type);
            onDismiss();
          },
        },
      ]}
      options={{noPaddingContent: true}}>
      <View>
        {isFinite(work_time) && (
          <>
            <View
              style={[
                sy['flex-row'],
                sy['items-center'],
                sy['gap-4'],
                sy['p-4'],
              ]}>
              <RadioButton
                checked={type === HOUR_TYPES.work}
                onPress={() => {
                  setType(HOUR_TYPES.work);
                  setDuration(calculated_work_time ?? work_time);
                }}
              />
              <View style={[sy['flex-1']]}>
                <Text>Fabrikant</Text>
                <Text style={[sy.smallRegular, sy['text-lightgray']]}>
                  {work_source}
                </Text>
              </View>
              <View style={[sy['flex-row'], sy['gap-2']]}>
                {isFinite(calculated_work_time) && (
                  <Text style={[sy.smallRegular, sy['line-through']]}>
                    {Format.number(work_time, 2)}&nbsp;u
                  </Text>
                )}
                <Text style={[sy.smallRegular, sy['self-start']]}>
                  {Format.number(calculated_work_time ?? work_time, 2)}&nbsp;u
                </Text>
              </View>
            </View>
            <Divider style={[sy['bg-gray95'], sy['ml-14']]} />
          </>
        )}
        {isFinite(sla?.duration) && (
          <>
            <View
              style={[
                sy['flex-row'],
                sy['items-center'],
                sy['gap-4'],
                sy['p-4'],
              ]}>
              <RadioButton
                checked={type === HOUR_TYPES.suggested}
                onPress={() => {
                  setType(HOUR_TYPES.suggested);
                  setDuration(sla?.duration);
                }}
              />
              <View style={[sy['flex-1']]}>
                <Text>SLA</Text>
                <Text style={[sy.smallRegular, sy['text-lightgray']]}>
                  Bahnkick
                </Text>
              </View>
              <Text style={[sy.smallRegular, sy['self-start']]}>
                {Format.number(sla.duration, 2)}&nbsp;u
              </Text>
            </View>
            <Divider style={[sy['bg-gray95'], sy['ml-14']]} />
          </>
        )}
        {isFinite(priceCheck?.suggested_duration) && (
          <>
            <View
              style={[
                sy['flex-row'],
                sy['items-center'],
                sy['gap-4'],
                sy['p-4'],
              ]}>
              <RadioButton
                checked={type === HOUR_TYPES.suggested}
                onPress={() => {
                  setType(HOUR_TYPES.suggested);
                  setDuration(priceCheck?.suggested_duration);
                }}
              />
              <View style={[sy['flex-1']]}>
                <Text>Meest goedgekeurd</Text>
                <Text style={[sy.smallRegular, sy['text-lightgray']]}>
                  Bahnkick
                </Text>
              </View>
              <Text style={[sy.smallRegular, sy['self-start']]}>
                {Format.number(priceCheck?.suggested_duration, 2)}&nbsp;u
              </Text>
            </View>
            <Divider style={[sy['bg-gray95'], sy['ml-14']]} />
          </>
        )}
        <View
          style={[sy['flex-row'], sy['items-center'], sy['gap-4'], sy['p-4']]}>
          <RadioButton
            checked={type === HOUR_TYPES.custom}
            onPress={() => setType(HOUR_TYPES.custom)}
          />
          <FormNumberInput
            style={[sy['flex-1']]}
            label="Aantal uren"
            value={duration}
            digits={2}
            onChangeNumber={setDuration}
            onFocus={() => setType(HOUR_TYPES.custom)}
          />
        </View>
      </View>
    </Dialog>
  );
};
DurationDialog.propTypes = {
  priceCheck: PropTypes.any,
  original_duration: PropTypes.any,
  duration: PropTypes.any,
  work_source: PropTypes.any,
  work_time: PropTypes.any,
  calculated_work_time: PropTypes.any,
  sla: PropTypes.any,
  onChange: PropTypes.any,
  onDismiss: PropTypes.any,
};

export default DurationDialog;
